window.fontsLoader = Promise.all([
  new FontFaceObserver('TT-common', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-bold', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-bold-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-book', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-book-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-demi-bold', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-demi-bold-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-extra-bold', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-extra-bold-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-extra-light', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-extra-light-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-light', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-light-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-medium', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-medium-italic', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-regular', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-thin', { weight: 400 }).load(),
  new FontFaceObserver('TT-common-thin-italic', { weight: 400 }).load(),
]);
